import React, { useEffect, useContext, useState } from "react";
import cx from "classnames";
import { getTimezoneByInstance } from "../../utils";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import Campaigns from "./Campaigns";
import { sortCampaigns } from "../../utils/helpers/arrayHelper";
import "./style.scss";

const CampaignInfoLayout = ({ data, campaignType }) => {
  const { t, siteCountry } = useContext(CustomI18nextContext);
  const timezone = getTimezoneByInstance(siteCountry);
  const [currentTab, setCurrentTab] = useState(CAMPAIGN_TYPES.NEW_USERS);
  const Tab = ({ type, label }) => (
    <button
      className={cx("campaign__tab button", { active: currentTab === type })}
      onClick={() => setCurrentTab(type)}
    >
      {label}
    </button>
  );
  const sortedNewUserCampaigns = sortCampaigns(
    data.newUserCampaigns.edges,
    timezone.tz
  );
  const sortedExistingUserCampaigns = sortCampaigns(
    data.existingUserCampaigns.edges,
    timezone.tz
  );

  useEffect(() => {
    setCurrentTab(campaignType);
  }, [campaignType]);

  return (
    <div className="campaign pt-5">
      <div className="container mb-5 py-5 page-content">
        <h1 className="text-center mb-4">{t("campaigns.title")}</h1>
        <div className="row justify-content-center mx-2 mx-sm-5">
          <div className="col-12 d-flex justify-content-center mt-3 mb-5">
            <Tab
              type={CAMPAIGN_TYPES.NEW_USERS}
              label={t("campaigns.newUser")}
            />
            <Tab
              type={CAMPAIGN_TYPES.EXISTING_USERS}
              label={t("campaigns.existingUser")}
            />
          </div>
          {currentTab === CAMPAIGN_TYPES.NEW_USERS && (
            <Campaigns data={sortedNewUserCampaigns} timezone={timezone} />
          )}
          {currentTab === CAMPAIGN_TYPES.EXISTING_USERS && (
            <Campaigns data={sortedExistingUserCampaigns} timezone={timezone} />
          )}
        </div>
      </div>
    </div>
  );
};

export const CAMPAIGN_TYPES = {
  NEW_USERS: "NEW_USERS",
  EXISTING_USERS: "EXISTING_USERS",
};

export default CampaignInfoLayout;
